
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexKA0Ya6Fby1fNBACvBZPSpFLC3u47CqmWzga0bOpfOKoMeta } from "/home/dario/data/sorgente/portaleFornitori/pages/index.vue?macro=true";
import { default as loginx_sw7xypkICS79V_oJgJ07qi_45A_45ZJG24P9W9n0DsHaYMeta } from "/home/dario/data/sorgente/portaleFornitori/pages/login.vue?macro=true";
import { default as resiODF5YtETuBW2EWVm2cV9pSjEllbwRT7HP0JBnAXFEuUMeta } from "/home/dario/data/sorgente/portaleFornitori/pages/merci/resi.vue?macro=true";
import { default as arrivoqrxXzET7s_45ZJdWHjlum1G0ZN7iQGUxdQqGfH2BEOG_oMeta } from "/home/dario/data/sorgente/portaleFornitori/pages/merci/arrivo.vue?macro=true";
import { default as arrivatiyQ0jdszqjPxyLz7b9QV99EYFKaJkL2QpgIbdU_45bCn4cMeta } from "/home/dario/data/sorgente/portaleFornitori/pages/merci/arrivati.vue?macro=true";
import { default as _91id_93ghFcgiHdI93rJtmCIgoiMUQkle9L5wM9gQ8wjYJ28bwMeta } from "/home/dario/data/sorgente/portaleFornitori/pages/movimenti/[id].vue?macro=true";
import { default as indexLRGwJXIx5svLsIKQUEthrZgFRWTyCDM7A4s5RVeF7FMMeta } from "/home/dario/data/sorgente/portaleFornitori/pages/movimenti/index.vue?macro=true";
import { default as incompleti55vuhAGtuB8pBxrK56ZvmKl4ZflNKnYwWKdSdbW2phkMeta } from "/home/dario/data/sorgente/portaleFornitori/pages/merci/incompleti.vue?macro=true";
import { default as createJaOeoJlYDcyoLXsnpVFissgVsLx02M72Apn2UVlxvcgMeta } from "/home/dario/data/sorgente/portaleFornitori/pages/movimenti/create.vue?macro=true";
import { default as usciterHz_45voN5O2b_45W6aB0BDMMbY8cbTebaz4MpMpWigpRmEMeta } from "/home/dario/data/sorgente/portaleFornitori/pages/movimenti/uscite.vue?macro=true";
import { default as ingressiieAJNzfR10tZcLzuWBUqi8hMxrJNKolqkS8UC21OyOUMeta } from "/home/dario/data/sorgente/portaleFornitori/pages/movimenti/ingressi.vue?macro=true";
import { default as assistenzafZydFfWlCiSJ15WwncIuwHonmPmjWT9M9_rXdiaU0asMeta } from "/home/dario/data/sorgente/portaleFornitori/pages/movimenti/assistenza.vue?macro=true";
import { default as _91id_93lFBGGSKdc7UZ4kL0xdrLYSngu98W3U1d_455B_45CkDiGeMMeta } from "/home/dario/data/sorgente/portaleFornitori/pages/ordini_acquisto/[id].vue?macro=true";
import { default as indexpgJ3h_uaZzCITIMK7EzXRaJOGJ064e5kER6_ZnINwxcMeta } from "/home/dario/data/sorgente/portaleFornitori/pages/ordini_vendita/index.vue?macro=true";
import { default as _91id_93RlxK6zsIDOSyzxqVvEqwYg95xyGTCmo_45iGuWlgcDZhwMeta } from "/home/dario/data/sorgente/portaleFornitori/pages/uscite_consegna/[id].vue?macro=true";
import { default as pronte_consegnatrrgERL_45fwpvNkaV5KityhQEMlKqgWfKaUehdcxFxMIMeta } from "/home/dario/data/sorgente/portaleFornitori/pages/merci/pronte_consegna.vue?macro=true";
import { default as _91id_93PD3YkDP_YQJtawii1w3Ia_K7FXsmhuRIk_45FmosLX_45ZcMeta } from "/home/dario/data/sorgente/portaleFornitori/pages/movimenti/update/[id].vue?macro=true";
import { default as indexgtx2v1QhyFHN2zj_45ljmmrgWoyptUB4CVp5MsoqyEDZAMeta } from "/home/dario/data/sorgente/portaleFornitori/pages/ordini_acquisto/index.vue?macro=true";
import { default as indexdmX7_45tPIuTgmZUBfGn2T8_UVla3njP9PqkqGCjU3ZbAMeta } from "/home/dario/data/sorgente/portaleFornitori/pages/uscite_consegna/index.vue?macro=true";
import { default as _91id_93VU3T7ZLUZqkIbwaNRZ87BJAXdcXHi__VzyTSnUhcnL8Meta } from "/home/dario/data/sorgente/portaleFornitori/pages/ticket_assistenza/[id].vue?macro=true";
import { default as indexeaXu4xkeQwye9ttt2xD3b_45Jr2RXbgsITrnlUk2bpN4cMeta } from "/home/dario/data/sorgente/portaleFornitori/pages/ticket_assistenza/index.vue?macro=true";
import { default as incompletiFqOkPmyHWN109snwuOrjdu_45JpQ_45c_OayUeg6ouJrK_EMeta } from "/home/dario/data/sorgente/portaleFornitori/pages/ordini_vendita/incompleti.vue?macro=true";
import { default as trasferimento_internolwEwlf9HSJp6k6USNIjIC2OttvqgZZDJ2mwRom1dKqYMeta } from "/home/dario/data/sorgente/portaleFornitori/pages/merci/trasferimento_interno.vue?macro=true";
import { default as assistenza_uscitedWgvYC2n0R8_45uhRUrizZGLcgu5MZfwJpWXu7Rc0OQDgMeta } from "/home/dario/data/sorgente/portaleFornitori/pages/movimenti/assistenza_uscite.vue?macro=true";
import { default as assistenza_ingressiv2ep2N0x2Ptdknm_45z6Q_zaCFCF8fN06fcolnJZ7HsRcMeta } from "/home/dario/data/sorgente/portaleFornitori/pages/movimenti/assistenza_ingressi.vue?macro=true";
import { default as pronte_consegnaLMGKgkSHyUfZqbQ8UF9uC6b5fdAFa_4555WujuBDDtkR0Meta } from "/home/dario/data/sorgente/portaleFornitori/pages/ordini_vendita/pronte_consegna.vue?macro=true";
import { default as presi_in_caricoPMdBeLgG3LKTS8XBUbjP3M8wnyPsJh_45NTD31ubtaooEMeta } from "/home/dario/data/sorgente/portaleFornitori/pages/ordini_acquisto/presi_in_carico.vue?macro=true";
import { default as index0K8Ap9nJmMXTKsLkZKTe4kjO026IDsFjr2LLG2hzTjkMeta } from "/home/dario/data/sorgente/portaleFornitori/pages/ordini_acquisto/ordini_expo/index.vue?macro=true";
import { default as consegne_in_corsonkLyp8xTP3G3pSf7d3UMFiVgouyJVovvlky2k9uE4H8Meta } from "/home/dario/data/sorgente/portaleFornitori/pages/uscite_consegna/consegne_in_corso.vue?macro=true";
import { default as consegne_programmataB1aAZPvvNMLnUDTP__8SWcJFInn4sLOflcFop5vvJc8Meta } from "/home/dario/data/sorgente/portaleFornitori/pages/uscite_consegna/consegne_programmata.vue?macro=true";
import { default as da_prendere_in_caricoLFvQIPrWBq7J_45oH6SD42Myx2ZkJWkg1aJf7AcoCdrg4Meta } from "/home/dario/data/sorgente/portaleFornitori/pages/ordini_acquisto/da_prendere_in_carico.vue?macro=true";
import { default as presi_in_caricoKhLec36_3E38nnOV2KzjHhSGYeZ7SjFlAx8raCKGN_45oMeta } from "/home/dario/data/sorgente/portaleFornitori/pages/ordini_acquisto/ordini_expo/presi_in_carico.vue?macro=true";
import { default as da_prendere_in_caricoNHiRxU7PxWa0Ubf_L3M0iCSczNAoYUPAatRrZj6lTY8Meta } from "/home/dario/data/sorgente/portaleFornitori/pages/ordini_acquisto/ordini_expo/da_prendere_in_carico.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/home/dario/data/sorgente/portaleFornitori/pages/index.vue")
  },
  {
    name: "login",
    path: "/login",
    meta: loginx_sw7xypkICS79V_oJgJ07qi_45A_45ZJG24P9W9n0DsHaYMeta || {},
    component: () => import("/home/dario/data/sorgente/portaleFornitori/pages/login.vue")
  },
  {
    name: "merci-resi",
    path: "/merci/resi",
    component: () => import("/home/dario/data/sorgente/portaleFornitori/pages/merci/resi.vue")
  },
  {
    name: "merci-arrivo",
    path: "/merci/arrivo",
    component: () => import("/home/dario/data/sorgente/portaleFornitori/pages/merci/arrivo.vue")
  },
  {
    name: "merci-arrivati",
    path: "/merci/arrivati",
    component: () => import("/home/dario/data/sorgente/portaleFornitori/pages/merci/arrivati.vue")
  },
  {
    name: "movimenti-id",
    path: "/movimenti/:id()",
    component: () => import("/home/dario/data/sorgente/portaleFornitori/pages/movimenti/[id].vue")
  },
  {
    name: "movimenti",
    path: "/movimenti",
    component: () => import("/home/dario/data/sorgente/portaleFornitori/pages/movimenti/index.vue")
  },
  {
    name: "merci-incompleti",
    path: "/merci/incompleti",
    component: () => import("/home/dario/data/sorgente/portaleFornitori/pages/merci/incompleti.vue")
  },
  {
    name: "movimenti-create",
    path: "/movimenti/create",
    component: () => import("/home/dario/data/sorgente/portaleFornitori/pages/movimenti/create.vue")
  },
  {
    name: "movimenti-uscite",
    path: "/movimenti/uscite",
    component: () => import("/home/dario/data/sorgente/portaleFornitori/pages/movimenti/uscite.vue")
  },
  {
    name: "movimenti-ingressi",
    path: "/movimenti/ingressi",
    component: () => import("/home/dario/data/sorgente/portaleFornitori/pages/movimenti/ingressi.vue")
  },
  {
    name: "movimenti-assistenza",
    path: "/movimenti/assistenza",
    component: () => import("/home/dario/data/sorgente/portaleFornitori/pages/movimenti/assistenza.vue")
  },
  {
    name: "ordini_acquisto-id",
    path: "/ordini_acquisto/:id()",
    component: () => import("/home/dario/data/sorgente/portaleFornitori/pages/ordini_acquisto/[id].vue")
  },
  {
    name: "ordini_vendita",
    path: "/ordini_vendita",
    component: () => import("/home/dario/data/sorgente/portaleFornitori/pages/ordini_vendita/index.vue")
  },
  {
    name: "uscite_consegna-id",
    path: "/uscite_consegna/:id()",
    component: () => import("/home/dario/data/sorgente/portaleFornitori/pages/uscite_consegna/[id].vue")
  },
  {
    name: "merci-pronte_consegna",
    path: "/merci/pronte_consegna",
    component: () => import("/home/dario/data/sorgente/portaleFornitori/pages/merci/pronte_consegna.vue")
  },
  {
    name: "movimenti-update-id",
    path: "/movimenti/update/:id()",
    component: () => import("/home/dario/data/sorgente/portaleFornitori/pages/movimenti/update/[id].vue")
  },
  {
    name: "ordini_acquisto",
    path: "/ordini_acquisto",
    component: () => import("/home/dario/data/sorgente/portaleFornitori/pages/ordini_acquisto/index.vue")
  },
  {
    name: "uscite_consegna",
    path: "/uscite_consegna",
    component: () => import("/home/dario/data/sorgente/portaleFornitori/pages/uscite_consegna/index.vue")
  },
  {
    name: "ticket_assistenza-id",
    path: "/ticket_assistenza/:id()",
    component: () => import("/home/dario/data/sorgente/portaleFornitori/pages/ticket_assistenza/[id].vue")
  },
  {
    name: "ticket_assistenza",
    path: "/ticket_assistenza",
    component: () => import("/home/dario/data/sorgente/portaleFornitori/pages/ticket_assistenza/index.vue")
  },
  {
    name: "ordini_vendita-incompleti",
    path: "/ordini_vendita/incompleti",
    component: () => import("/home/dario/data/sorgente/portaleFornitori/pages/ordini_vendita/incompleti.vue")
  },
  {
    name: "merci-trasferimento_interno",
    path: "/merci/trasferimento_interno",
    component: () => import("/home/dario/data/sorgente/portaleFornitori/pages/merci/trasferimento_interno.vue")
  },
  {
    name: "movimenti-assistenza_uscite",
    path: "/movimenti/assistenza_uscite",
    component: () => import("/home/dario/data/sorgente/portaleFornitori/pages/movimenti/assistenza_uscite.vue")
  },
  {
    name: "movimenti-assistenza_ingressi",
    path: "/movimenti/assistenza_ingressi",
    component: () => import("/home/dario/data/sorgente/portaleFornitori/pages/movimenti/assistenza_ingressi.vue")
  },
  {
    name: "ordini_vendita-pronte_consegna",
    path: "/ordini_vendita/pronte_consegna",
    component: () => import("/home/dario/data/sorgente/portaleFornitori/pages/ordini_vendita/pronte_consegna.vue")
  },
  {
    name: "ordini_acquisto-presi_in_carico",
    path: "/ordini_acquisto/presi_in_carico",
    component: () => import("/home/dario/data/sorgente/portaleFornitori/pages/ordini_acquisto/presi_in_carico.vue")
  },
  {
    name: "ordini_acquisto-ordini_expo",
    path: "/ordini_acquisto/ordini_expo",
    component: () => import("/home/dario/data/sorgente/portaleFornitori/pages/ordini_acquisto/ordini_expo/index.vue")
  },
  {
    name: "uscite_consegna-consegne_in_corso",
    path: "/uscite_consegna/consegne_in_corso",
    component: () => import("/home/dario/data/sorgente/portaleFornitori/pages/uscite_consegna/consegne_in_corso.vue")
  },
  {
    name: "uscite_consegna-consegne_programmata",
    path: "/uscite_consegna/consegne_programmata",
    component: () => import("/home/dario/data/sorgente/portaleFornitori/pages/uscite_consegna/consegne_programmata.vue")
  },
  {
    name: "ordini_acquisto-da_prendere_in_carico",
    path: "/ordini_acquisto/da_prendere_in_carico",
    component: () => import("/home/dario/data/sorgente/portaleFornitori/pages/ordini_acquisto/da_prendere_in_carico.vue")
  },
  {
    name: "ordini_acquisto-ordini_expo-presi_in_carico",
    path: "/ordini_acquisto/ordini_expo/presi_in_carico",
    component: () => import("/home/dario/data/sorgente/portaleFornitori/pages/ordini_acquisto/ordini_expo/presi_in_carico.vue")
  },
  {
    name: "ordini_acquisto-ordini_expo-da_prendere_in_carico",
    path: "/ordini_acquisto/ordini_expo/da_prendere_in_carico",
    component: () => import("/home/dario/data/sorgente/portaleFornitori/pages/ordini_acquisto/ordini_expo/da_prendere_in_carico.vue")
  }
]